import { isValidPhoneNumber } from 'libphonenumber-js';

export const PHONE_INPUT_MAX_LENGTH = 13;

export const sanitizePhoneInput = (raw: string): string => {
    let value = raw;

    if (!value.startsWith('+')) {
        value = `+${value.replace(/[^0-9]/g, '')}`;
    }

    return `+${value.slice(1).replace(/[^0-9]/g, '')}`;
};

export const isSanitizedPhoneValid = (phone: string): boolean => {
    if (!phone || phone === '+') return false;
    return isValidPhoneNumber(phone);
};

export const hasPhoneInputValue = (phone: string): boolean => Boolean(phone && phone !== '+');

export const normalizePhoneForSave = (phone: string): string => {
    const cleaned = sanitizePhoneInput(phone);
    return cleaned === '+' ? '' : cleaned;
};
